module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SPIC.fc1c6ae9.png";